"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIconMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _iconSizeMixin = require("../iconSizeMixin");
var _spaceMixin = require("../spaceMixin");
/** @class ButtonIconMixin */
/** @method */
var ButtonIconMixin = function ButtonIconMixin(props) {
  var iconPosition = props.iconPosition,
    iconSize = props.iconSize;
  return (0, _styledToken.default)('Button.icon.marginX', function (marginX) {
    return (0, _styledComponents.css)(["margin-", ":", ";", ""], iconPosition === 'start' ? 'right' : 'left', marginX ? marginX + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), (0, _iconSizeMixin.iconSizeMixin)(Object.assign({}, props, {
      iconSize: iconSize
    })));
  })(props);
};
exports.ButtonIconMixin = ButtonIconMixin;